/**
 * CAPDAC Studio — Theme JavaScript
 * Vanilla JS, no dependencies
 */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    initMobileNav();
    initStickyHeader();
    initScrollAnimations();
    initProductGallery();
    initQuantityButtons();
    initAnnouncementBar();
  });

  /* ── Mobile Navigation ──────────────────────────────────────────────── */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-toggle]');
    var closeBtn = document.querySelector('[data-mobile-close]');
    var overlay = document.querySelector('[data-mobile-overlay]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    function openNav() {
      nav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      // Focus first link
      var firstLink = nav.querySelector('a');
      if (firstLink) firstLink.focus();
    }

    function closeNav() {
      nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    toggle.addEventListener('click', openNav);
    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  /* ── Sticky Header ──────────────────────────────────────────────────── */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var scrollThreshold = 60;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.pageYOffset > scrollThreshold) {
            header.classList.add('is-scrolled');
          } else {
            header.classList.remove('is-scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Scroll Animations ──────────────────────────────────────────────── */
  function initScrollAnimations() {
    var elements = document.querySelectorAll('.animate-on-scroll');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      elements.forEach(function(el) { observer.observe(el); });
    } else {
      // Fallback: just show everything
      elements.forEach(function(el) { el.classList.add('is-visible'); });
    }
  }

  /* ── Product Image Gallery ──────────────────────────────────────────── */
  function initProductGallery() {
    var mainImage = document.querySelector('.product-page__main-image img');
    var thumbnails = Array.prototype.slice.call(document.querySelectorAll('.product-page__thumbnails img'));
    var prevBtn = document.querySelector('[data-gallery-arrow="prev"]');
    var nextBtn = document.querySelector('[data-gallery-arrow="next"]');

    if (!mainImage || !thumbnails.length) return;

    var currentIndex = 0;

    function updateGallery(index) {
      if (index < 0) index = thumbnails.length - 1;
      if (index >= thumbnails.length) index = 0;
      currentIndex = index;

      var targetThumb = thumbnails[currentIndex];
      var newSrc = targetThumb.src.replace(/width=\d+/, 'width=800');
      mainImage.src = newSrc;
      if (targetThumb.alt) mainImage.alt = targetThumb.alt;

      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      targetThumb.classList.add('is-active');

      if (targetThumb.scrollIntoView) {
        targetThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    thumbnails.forEach(function(thumb, idx) {
      thumb.addEventListener('click', function() {
        updateGallery(idx);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        updateGallery(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        updateGallery(currentIndex + 1);
      });
    }

    var thumbPrevBtn = document.querySelector('[data-thumb-arrow="prev"]');
    var thumbNextBtn = document.querySelector('[data-thumb-arrow="next"]');
    var thumbContainer = document.querySelector('[data-thumbnails-container]');

    if (thumbPrevBtn && thumbContainer) {
      thumbPrevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        thumbContainer.scrollBy({ left: -216, behavior: 'smooth' });
      });
    }

    if (thumbNextBtn && thumbContainer) {
      thumbNextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        thumbContainer.scrollBy({ left: 216, behavior: 'smooth' });
      });
    }
  }

  /* ── Quantity Buttons ───────────────────────────────────────────────── */
  function initQuantityButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-qty-btn]');
      if (!btn) return;

      var wrapper = btn.closest('.product-page__quantity, .cart-item__quantity');
      if (!wrapper) return;

      var input = wrapper.querySelector('input[type="number"]');
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 999;

      if (btn.dataset.qtyBtn === 'minus' && current > min) {
        input.value = current - 1;
      } else if (btn.dataset.qtyBtn === 'plus' && current < max) {
        input.value = current + 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ── Announcement Bar ───────────────────────────────────────────────── */
  function initAnnouncementBar() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    var closeBtn = bar.querySelector('.announcement-bar__close');
    if (!closeBtn) return;

    // Check if already dismissed
    if (sessionStorage.getItem('capdac-announcement-closed') === 'true') {
      bar.style.display = 'none';
      return;
    }

    closeBtn.addEventListener('click', function() {
      bar.style.display = 'none';
      sessionStorage.setItem('capdac-announcement-closed', 'true');
    });
  }

})();

/* ── Global Quick Add & Quantity Handlers (Optimistic Instant UI + Full Sync) ── */
window.handleQuickAdd = function(btn, variantId) {
  var container = btn.closest('.quick-add-container');
  var qtyBox = container ? container.querySelector('.quick-qty-box') : null;
  var qtyDisplay = qtyBox ? qtyBox.querySelector('.qty-display') : null;

  // Instant Optimistic Feedback
  if (btn) btn.style.display = 'none';
  if (qtyBox) {
    qtyBox.style.display = 'flex';
    qtyBox.setAttribute('data-qty', '1');
    if (qtyDisplay) qtyDisplay.innerText = '1';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  })
  .then(function() {
    return fetch('/cart.js').then(function(res) { return res.json(); });
  })
  .then(function(cart) {
    if (typeof renderDrawerCart === 'function') {
      renderDrawerCart(cart);
    }
    var drawer = document.getElementById('cartDrawerBackdrop');
    if (drawer && !drawer.classList.contains('open')) {
      drawer.classList.add('open');
    }
  })
  .catch(function(err) {
    console.error('Quick add error:', err);
    // Rollback if error
    if (btn) btn.style.display = 'flex';
    if (qtyBox) qtyBox.style.display = 'none';
  });
};

window.handleQuickQtyChange = function(btn, delta, variantId) {
  var qtyBox = btn.closest('.quick-qty-box');
  var container = btn.closest('.quick-add-container');
  var addBtn = container ? container.querySelector('.btn-quick-add') : null;
  var qtyDisplay = qtyBox ? qtyBox.querySelector('.qty-display') : null;

  var currentQty = parseInt(qtyBox ? (qtyBox.getAttribute('data-qty') || '1') : '1', 10);
  var newQty = Math.max(0, currentQty + delta);

  // Instant Optimistic UI Update (Zero Latency)
  if (newQty <= 0) {
    if (qtyBox) qtyBox.style.display = 'none';
    if (addBtn) addBtn.style.display = 'flex';
  } else {
    if (qtyBox) {
      qtyBox.setAttribute('data-qty', String(newQty));
      if (qtyDisplay) qtyDisplay.innerText = String(newQty);
    }
  }

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(variantId), quantity: newQty })
  })
  .then(function() {
    return fetch('/cart.js').then(function(res) { return res.json(); });
  })
  .then(function(cart) {
    if (typeof renderDrawerCart === 'function') {
      renderDrawerCart(cart);
    }
  })
  .catch(function(err) {
    console.error('Quick qty change error:', err);
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (typeof renderDrawerCart === 'function') renderDrawerCart(cart);
      });
  });
};

document.addEventListener('DOMContentLoaded', function() {
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      if (typeof renderDrawerCart === 'function') {
        renderDrawerCart(cart);
      }
    })
    .catch(function(e) { console.error('Initial cart fetch error:', e); });
});